import * as React from 'react';
import styled from 'styled-components';
import {AppAssetKind} from './appAssetCrop';

export const BotaoAsset = styled.button`
  && {
    font: inherit;
    font-size: 14px;
    font-weight: 600;
    border: 1px solid #c9d5e2;
    border-radius: 9px;
    padding: 10px 16px;
    background: white;
    color: #18334e;
    cursor: pointer;
    line-height: 1.4;
    min-height: 42px;
    transition: background 160ms, box-shadow 160ms;
  }
  &&:hover {
    background: #edf4fb;
  }
  &&:focus-visible {
    outline: 3px solid #3b8eea;
    outline-offset: 3px;
  }
  &&:disabled {
    opacity: 0.5;
    cursor: wait;
  }
  &&[data-primary='true'] {
    background: #1264b9;
    border-color: #1264b9;
    color: white;
  }
  &&[aria-pressed='true'] {
    background: #e0edf9;
    border-color: #1264b9;
    color: #124f8c;
  }
  @media (prefers-reduced-motion: reduce) {
    && {
      transition: none;
    }
  }
`;
export const TextoAuxiliar = styled.p`
  && {
    font-size: 13px;
    line-height: 1.6;
    color: #586b80;
    margin: 8px 0;
  }
`;
const Aparelho = styled.div`
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  background: #dfe9f3;
  border: 6px solid #203145;
  border-radius: 28px;
  box-shadow: 0 12px 24px #19344b22;
  &:after {
    content: '';
    position: absolute;
    bottom: 7px;
    width: 32%;
    height: 3px;
    left: 34%;
    border-radius: 4px;
    background: #fff9;
  }
`;
export interface PreviewProps {
  kind: AppAssetKind;
  url?: string | null;
  appLabel?: string;
  wallpaperLightUrl?: string;
  wallpaperDarkUrl?: string;
}
export const AppAssetPreview = ({
  kind,
  url,
  appLabel = 'Seu aplicativo',
  wallpaperLightUrl,
  wallpaperDarkUrl,
}: PreviewProps) => {
  const [escuro, setEscuro] = React.useState(false);
  const wallpaper = escuro ? wallpaperDarkUrl : wallpaperLightUrl;
  return (
    <div style={{display: 'grid', justifyItems: 'center', gap: 18}}>
      {kind === 'icon' ? (
        <>
          <div
            role="group"
            aria-label="Aparência do preview"
            style={{display: 'flex', gap: 6}}
          >
            <BotaoAsset
              type="button"
              aria-pressed={!escuro}
              onClick={() => setEscuro(false)}
            >
              Claro
            </BotaoAsset>
            <BotaoAsset
              type="button"
              aria-pressed={escuro}
              onClick={() => setEscuro(true)}
            >
              Escuro
            </BotaoAsset>
          </div>
          <Aparelho
            style={{
              width: 190,
              height: 358,
              backgroundColor: escuro ? '#203145' : '#c2d9e9',
              backgroundImage: wallpaper
                ? `url(${JSON.stringify(wallpaper)})`
                : undefined,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div
              style={{
                textAlign: 'center',
                paddingTop: 16,
                fontSize: 12,
                color: escuro ? '#fff' : '#21364e',
                fontWeight: 600,
              }}
            >
              9:41 <span style={{float: 'right', marginRight: 13}}>▰</span>
            </div>
            <div
              style={{margin: '38px auto 0', width: 92, textAlign: 'center'}}
            >
              {url && (
                <img
                  src={url}
                  alt="Ícone do aplicativo"
                  style={{
                    display: 'block',
                    width: 60,
                    height: 60,
                    borderRadius: '22.37%',
                    margin: 'auto',
                    boxShadow: '0 3px 8px #0002',
                  }}
                />
              )}
              <div
                style={{
                  fontSize: 11,
                  marginTop: 7,
                  color: escuro ? '#fff' : '#132e48',
                  textShadow: escuro ? '0 1px 4px #000' : '0 1px 4px #fff',
                  overflowWrap: 'anywhere',
                }}
              >
                {appLabel}
              </div>
            </div>
          </Aparelho>
        </>
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          {[
            {nome: 'Celular', largura: 112, altura: 243},
            {nome: 'Tablet', largura: 150, altura: 200},
          ].map((tela) => (
            <div key={tela.nome} style={{textAlign: 'center'}}>
              <Aparelho
                style={{
                  boxSizing: 'content-box',
                  width: tela.largura,
                  height: tela.altura,
                  borderRadius: 20,
                }}
              >
                {url && (
                  <img
                    src={url}
                    alt={`Tela de abertura no ${tela.nome.toLowerCase()}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                )}
              </Aparelho>
              <TextoAuxiliar>{tela.nome}</TextoAuxiliar>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
